import * as ko from "knockout";
import { person } from "../person/person";

export class incident_subscriber extends person {
  is_subscribed: KnockoutObservable<boolean>;

  constructor(item?: any) {
    super(item);
    this.is_subscribed = ko.observable(item?.is_subscribed);
  }
}
